module.exports = __webpack_public_path__ + "img/logo-full.da8e42c8.png";